import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();
const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : (window.location.href = "/")
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="sso.test.authrock.com"
      clientId="FnN7XzGa5VYkoFf36AVOiWoCTB7IFp1P"
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience="urn:ql-api:swift_app-207711:Test"
      cacheLocation="localstorage"
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
